import { create, type StoreApi, type UseBoundStore } from 'zustand';

import { createPlayerSlice } from './player';
import { createQueueSlice } from './queue';
import { createSessionSlice } from './session';
import type { TvStore } from './types';
import { createUiSlice } from './ui';

export type TvStoreApi = UseBoundStore<StoreApi<TvStore>>;

/**
 * One zustand store, four slices (docs/04 §1): `session`, `queue`, `player`, `ui`.
 * RTDB listeners (WP1.6) feed `setMeta` / `setQueue` / `setRemotePlayer` / `setMembers`;
 * screens read with selectors. `createTvStore()` gives tests an isolated instance.
 */
export function createTvStore(): TvStoreApi {
  return create<TvStore>()((...a) => ({
    ...createSessionSlice(...a),
    ...createQueueSlice(...a),
    ...createPlayerSlice(...a),
    ...createUiSlice(...a),
  }));
}

export const useStore: TvStoreApi = createTvStore();

export * from './player';
export * from './queue';
export * from './session';
export type { TvStore } from './types';
export * from './ui';
